import { type ReactNode, createContext, useContext, useRef } from 'react';
import { CartStoreApi, createCartStore, initCartStore } from './model';

interface CartStoreProviderProps {
  children: ReactNode;
}

const CartStoreContext = createContext<CartStoreApi | undefined>(undefined);

const useCartStoreContext = () => {
  const cartStoreContext = useContext(CartStoreContext);

  if (!cartStoreContext) {
    throw new Error(`useCartStore must be used within CartStoreProvider`);
  }

  return cartStoreContext;
};

const CartStoreProvider = ({ children }: CartStoreProviderProps) => {
  const storeRef = useRef<CartStoreApi | null>(null);

  if (storeRef.current === null) {
    storeRef.current = createCartStore(initCartStore());
  }

  return <CartStoreContext.Provider value={storeRef.current}>{children}</CartStoreContext.Provider>;
};

export { CartStoreProvider, useCartStoreContext };
